/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Created_OnInputs */

const en_pdf_cv_review_created_on = /** @type {(inputs: Pdf_Cv_Review_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created on`)
};

const de_pdf_cv_review_created_on = /** @type {(inputs: Pdf_Cv_Review_Created_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt am`)
};

/**
* | output |
* | --- |
* | "Created on" |
*
* @param {Pdf_Cv_Review_Created_OnInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_created_on = /** @type {((inputs?: Pdf_Cv_Review_Created_OnInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Created_OnInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_created_on(inputs)
	return en_pdf_cv_review_created_on(inputs)
});